import { useMemo } from 'react'
import type { JwtPayload } from '@/lib/token'

export function usePermissions(user: JwtPayload | null) {
  return useMemo(() => {
    const permissions = user?.permissions ?? []

    function can(permission: string): boolean {
      if (permissions.includes('*')) return true
      if (permissions.includes(permission)) return true
      // check wildcard: "users:*" matches "users:read"
      const [namespace] = permission.split(':')
      return permissions.includes(`${namespace}:*`)
    }

    return { can, permissions }
  }, [user])
}
